// extracted by mini-css-extract-plugin
export default {"icons":"CustomNotes_icons__ssnNN","no-notes-icon":"CustomNotes_no-notes-icon__JFVqw"};